// src/Pages/Assets/futuresComponentes/HistoryList.jsx
import React from "react";
import {
  Box,
  Grid,
  LinearProgress,
  Paper,
  Typography,
  Chip,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import HistoryIcon from "@mui/icons-material/History";
import HistoryCard from "./HistoryCard";

export default function HistoryList({
  rows,
  loading,
  brand,
  maxHeight = "58vh",
}) {
  const theme = useTheme();
  const borderCol = alpha(theme.palette.divider, 0.6);

  if (loading) {
    return (
      <LinearProgress
        sx={{
          height: 2,
          mb: 1,
          "& .MuiLinearProgress-bar": { bgcolor: brand },
        }}
      />
    );
  }

  if (!rows || rows.length === 0) {
    return (
      <Paper
        variant="outlined"
        sx={{ p: 3, textAlign: "center", borderRadius: 2 }}
      >
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          No history
        </Typography>
      </Paper>
    );
  }

  const groups = Object.entries(
    rows.reduce((acc, r) => {
      const key =
        (r.created_at || r.updated_at || "").slice(0, 10) || "Unknown";
      acc[key] = acc[key] || [];
      acc[key].push(r);
      return acc;
    }, {})
  ).sort((a, b) => (a[0] < b[0] ? 1 : -1));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.2,
        maxHeight,
        overflowY: "auto",
        pr: 1,
      }}
    >
      {groups.map(([date, items]) => (
        <Paper
          key={date}
          sx={{
            p: 1.25,
            borderRadius: 2,
            border: `1px solid ${borderCol}`,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <HistoryIcon fontSize="small" />
            <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
              {date}
            </Typography>
            <Chip
              size="small"
              label={items.length}
              sx={{ ml: "auto", bgcolor: alpha(brand, 0.15) }}
            />
          </Box>
          <Grid container spacing={1.2}>
            {items.map((r) => (
              <Grid item xs={12} md={6} key={r._id}>
                <HistoryCard row={r} />
              </Grid>
            ))}
          </Grid>
        </Paper>
      ))}
    </Box>
  );
}
